import React from 'react';
import styles from './Container.module.scss';
import useIsRtl from '../../../app/helpers/isRtl';

function Container({ children, className }) {
  const isRtl = useIsRtl();
  return (
    <div
      className={`${styles['container']} ${className ?? ''} ${
        isRtl ? 'rtl' : ''
      }`}
    >
      {children}
    </div>
  );
}

export default Container;
